import css from 'styled-jsx/css';
import Colors from './colors';
import FontSizes from './fontSizes';
import Breakpoints from './breakpoints';

const { maxMobile } = Breakpoints;
const {
    body,
    bodyAlt,
    bodyLight,
} = Colors;

const {
    xsBase,
    smBase,
    xxlBase,
} = FontSizes;

export default css`{
    .mainSection {
        display: flex;
        flex-direction: row;
        margin: 13px 0 18px 0;
        justify-content: space-between;
    }
    .mainSection h1 {
        color: ${body};
        font-size: ${xxlBase};
        line-height: 29px;
        font-weight: bold;
    }
    .rightSection {
        margin-top: 4px;
    }
    .headingInfo {
        color: ${bodyLight};
        line-height: 14px;
        margin-top: 3px;
    }
    .headingContainer {
       border-radius: 3px;
       background-color: ${bodyAlt};
       box-shadow: 0 2px 6px 0 rgba(173, 193, 207, 0.15);
       border: solid 1px #eaeff3;
       margin-bottom: 15px;
    }
    .heading {
        padding: 9px 15px;
        color:  ${body};
        font-size: ${smBase};
        font-weight: 600;
        border-bottom: solid 1px #eaeff3;
        background-color: #f5f8fd;
    }
    .back {
        font-size: ${smBase};
        color: ${body};
        font-weight: bold;
    }
    @media ${maxMobile} {
        .mainSection {
            display: block;
        }
        .leftSection {
            text-align: center;
        }
        .buttonSection {
            max-width: 200px;
            margin: 0 auto;
            text-align: center;
        }
        .mainSection h1 {
            margin-bottom: 5px;
        }
        .headingInfo {
            margin-bottom: 10px;
        }
    }
}`;



// WEBPACK FOOTER //
// ./src/styles/commonStyle.js